import { INACTIVITY_LOG_OUT_SNACKBAR } from "./constants"

export const setInactivityLogOutMessage = (message: string) => {
  sessionStorage.setItem(INACTIVITY_LOG_OUT_SNACKBAR, message)
}

export const removeInactivityLogOutMessage = () => {
  sessionStorage.removeItem(INACTIVITY_LOG_OUT_SNACKBAR)
}

export const getInactivityLogOutMessage = (): string => {
  return sessionStorage.getItem(INACTIVITY_LOG_OUT_SNACKBAR)
}
